/* cart-drawer-enhancements: begin */
(function () {
  'use strict';

  function getMoneyFormatString() {
    try {
      var el = document.getElementById('wetheme-global');
      if (!el) {
        return '${{amount}}';
      }
      return JSON.parse(el.textContent).moneyFormat || '${{amount}}';
    } catch (e) {
      return '${{amount}}';
    }
  }

  function formatMoney(cents) {
    var formatString = getMoneyFormatString();
    var placeholderRegex = /\{\{\s*(\w+)\s*\}\}/;
    var m = formatString.match(placeholderRegex);
    if (typeof cents === 'string') {
      cents = cents.replace('.', '');
    }
    if (!m) {
      return String(cents);
    }

    function formatWithDelimiters(number, precision, thousands, decimal) {
      if (precision === null || precision === undefined) {
        precision = 2;
      }
      thousands = thousands || ',';
      decimal = decimal || '.';
      if (isNaN(number) || number == null) {
        return '0';
      }
      number = (number / 100.0).toFixed(precision);
      var parts = number.split('.');
      var dollarsAmount = parts[0].replace(/(\d)(?=(\d\d\d)+(?!\d))/g, '$1' + thousands);
      var centsAmount = parts[1] ? decimal + parts[1] : '';
      return dollarsAmount + centsAmount;
    }

    var value = '';
    switch (m[1]) {
      case 'amount':
        value = formatWithDelimiters(cents, 2);
        break;
      case 'amount_no_decimals':
        value = formatWithDelimiters(cents, 0);
        break;
      case 'amount_with_comma_separator':
        value = formatWithDelimiters(cents, 2, '.', ',');
        break;
      case 'amount_no_decimals_with_comma_separator':
        value = formatWithDelimiters(cents, 0, '.', ',');
        break;
      case 'amount_no_decimals_with_space_separator':
        value = formatWithDelimiters(cents, 0, ' ');
        break;
      default:
        value = formatWithDelimiters(cents, 2);
    }
    return formatString.replace(placeholderRegex, value);
  }

  function shippingSubtotalCents(cart) {
    var items = cart.items || [];
    var sum = 0;
    for (var i = 0; i < items.length; i++) {
      if (items[i].requires_shipping) {
        sum += items[i].final_line_price;
      }
    }
    var discounts = cart.cart_level_discount_applications || [];
    var d = 0;
    for (var j = 0; j < discounts.length; j++) {
      d += discounts[j].total_allocated_amount;
    }
    return sum - d;
  }

  function updateFreeShippingBar(cart) {
    var bar = document.getElementById('cart-free-shipping-bar');
    if (!bar || !cart) {
      return;
    }
    var threshold = parseInt(bar.getAttribute('data-threshold-cents'), 10);
    if (!threshold || threshold <= 0) {
      return;
    }

    if (!cart.item_count || !cart.requires_shipping) {
      bar.setAttribute('hidden', '');
      return;
    }
    bar.removeAttribute('hidden');

    var subtotal = shippingSubtotalCents(cart);
    var progress = Math.min(1, subtotal / threshold);
    var fill = bar.querySelector('.cart-free-shipping-bar__fill');
    var track = bar.querySelector('.cart-free-shipping-bar__track');
    var msg = bar.querySelector('.cart-free-shipping-bar__message');
    if (fill) {
      fill.style.setProperty('--progress', String(progress));
    }
    if (track) {
      track.setAttribute('aria-valuenow', String(Math.round(progress * 100)));
    }

    var reachedHtml = bar.getAttribute('data-reached-html') || '';
    var unreachedHtml = bar.getAttribute('data-unreached-html') || '';
    if (subtotal >= threshold) {
      if (msg) {
        msg.innerHTML = reachedHtml;
      }
    } else {
      var remaining = threshold - subtotal;
      var formatted = formatMoney(remaining);
      var parts = unreachedHtml.split('[[amount]]');
      var out = parts.join('<span class="cart-free-shipping-bar__amount">' + formatted + '</span>');
      if (msg) {
        msg.innerHTML = out;
      }
    }
  }

  function updateSavingsRow(cart) {
    var row = document.querySelector('.js-cart-drawer-savings');
    if (!row || !cart) {
      return;
    }
    var savings = (cart.original_total_price || 0) - (cart.total_price || 0);
    var amt = row.querySelector('.cart-drawer__savings-amount');
    if (savings > 0) {
      row.removeAttribute('hidden');
      if (amt) {
        amt.innerHTML = formatMoney(savings);
      }
    } else {
      row.setAttribute('hidden', '');
    }
  }

  function cartRoot() {
    var form = document.querySelector('.cart-drawer-form');
    var languageUrl = form && form.getAttribute('data-language-url');
    if (!languageUrl || languageUrl === '/') {
      return '';
    }
    return languageUrl;
  }

  function syncCrossSell(cart) {
    var root = document.querySelector('.cart-drawer__complementary-products');
    if (!root) {
      return;
    }
    var items = (cart && cart.items) || [];
    var inCart = {};
    for (var i = 0; i < items.length; i++) {
      inCart[String(items[i].product_id)] = true;
    }
    var cards = root.querySelectorAll('.cart-drawer__cross-sell-card');
    var visible = 0;
    for (var c = 0; c < cards.length; c++) {
      var card = cards[c];
      var hide = !cart || !cart.item_count || inCart[card.getAttribute('data-product-id')];
      if (hide) {
        card.setAttribute('hidden', '');
      } else {
        card.removeAttribute('hidden');
        visible += 1;
      }
    }
    if (!cart || !cart.item_count || visible === 0) {
      root.setAttribute('hidden', '');
    } else {
      root.removeAttribute('hidden');
    }
    root.classList.toggle('cart-drawer__complementary-products--slider', visible > 1);
    root.style.setProperty('--item-count', String(visible));
    var list = root.querySelector('.cart-drawer__complementary-products-list');
    if (list) {
      list.style.setProperty('--item-count', String(visible));
    }
  }

  function bindCrossSellAdd() {
    var root = document.querySelector('.cart-drawer__complementary-products');
    if (!root || root.__bkCrossSellBound) {
      return;
    }
    root.__bkCrossSellBound = true;
    root.addEventListener('click', function (event) {
      var button = event.target.closest('.cart-drawer__cross-sell-add[data-variant-id]');
      if (!button || button.getAttribute('aria-busy') === 'true') {
        return;
      }
      event.preventDefault();
      var variantId = button.getAttribute('data-variant-id');
      if (!variantId) {
        return;
      }
      button.setAttribute('aria-busy', 'true');
      button.disabled = true;
      var rootPath = cartRoot();
      fetch(rootPath + '/cart/add.js', {
        method: 'POST',
        credentials: 'same-origin',
        headers: {
          'Content-Type': 'application/json',
          'X-Requested-With': 'XMLHttpRequest',
        },
        body: JSON.stringify({ items: [{ id: Number(variantId), quantity: 1 }] }),
      })
        .then(function (response) {
          if (!response.ok) {
            throw new Error('add failed');
          }
          return fetch(rootPath + '/cart.js', { credentials: 'same-origin' });
        })
        .then(function (response) {
          return response.json();
        })
        .then(function (cart) {
          var drawer = window.wetheme && window.wetheme.cartDrawer;
          if (drawer && typeof drawer.updateCartDrawer === 'function') {
            drawer.updateCartDrawer(cart);
          } else {
            syncCrossSell(cart);
          }
        })
        .catch(function () {
          button.disabled = false;
          button.removeAttribute('aria-busy');
        });
    });
  }

  function onCart(cart) {
    updateFreeShippingBar(cart);
    updateSavingsRow(cart);
    syncCrossSell(cart);
    positionPaypalUpstreamMessaging();
  }

  function positionPaypalUpstreamMessaging() {
    var aside = document.getElementById('cartSlideoutAside');
    if (!aside) {
      return;
    }
    var msg =
      aside.querySelector('#paypal-upstream-messaging-cart-drawer') ||
      aside.querySelector('.paypal-upstream-messaging-cart-drawer');
    var checkout = aside.querySelector('.cart-drawer__slide-checkout .cart-drawer__checkout-primary');
    var slide = aside.querySelector('.slide-checkout-buttons.cart-drawer__slide-checkout');
    if (!msg || !checkout || !slide || !slide.contains(checkout)) {
      return;
    }
    if (msg.parentNode === slide && checkout.nextElementSibling === msg) {
      return;
    }
    checkout.after(msg);
  }

  function bindCartSlideoutOverlay() {
    var w = window.wetheme;
    var drawer = w && w.drawer;
    var slideout = drawer && drawer.slideouts && drawer.slideouts.right;
    if (!slideout || slideout.__bkCartOverlayBound) {
      return !!(slideout && slideout.__bkCartOverlayBound);
    }
    var overlayEl = document.getElementById('slideout-overlay');
    if (!overlayEl) {
      return false;
    }
    slideout.__bkCartOverlayBound = true;
    slideout.on('beforeopen', function () {
      if (typeof jQuery !== 'undefined') {
        jQuery(overlayEl).fadeIn();
      } else {
        overlayEl.style.display = 'block';
      }
    });
    slideout.on('beforeclose', function () {
      if (typeof jQuery !== 'undefined') {
        jQuery(overlayEl).fadeOut();
      } else {
        overlayEl.style.display = 'none';
      }
    });
    overlayEl.addEventListener('click', function cartDrawerOverlayClose() {
      if (typeof slideout.isOpen === 'function' && slideout.isOpen()) {
        slideout.close();
      }
    });
    return true;
  }

  function patchCartDrawerInstance() {
    var w = window.wetheme;
    var cd = w && w.cartDrawer;
    if (!cd || typeof cd.updateCartDrawer !== 'function' || cd.__bkCartDrawerEnhancementsPatched) {
      return !!cd && !!cd.__bkCartDrawerEnhancementsPatched;
    }
    var inner = cd.updateCartDrawer;
    cd.__bkCartDrawerEnhancementsPatched = true;
    cd.updateCartDrawer = function (cart) {
      var ret = inner.apply(this, arguments);
      function notify() {
        try {
          onCart(cart);
        } catch (e) {}
        document.dispatchEvent(
          new CustomEvent('wetheme:cart-drawer-updated', {
            detail: { cart: cart },
            bubbles: true,
          })
        );
      }
      if (ret && typeof ret.then === 'function') {
        ret.then(notify).catch(notify);
      } else {
        notify();
      }
      return ret;
    };
    return true;
  }

  function initFromInitialCart() {
    var el = document.getElementById('initial-cart');
    if (!el) {
      return;
    }
    try {
      var cart = JSON.parse(el.textContent);
      onCart(cart);
    } catch (e) {}
  }

  function initPaypalMessagingObserver() {
    var aside = document.getElementById('cartSlideoutAside');
    if (!aside || typeof MutationObserver === 'undefined') {
      return;
    }
    var obs = new MutationObserver(function () {
      positionPaypalUpstreamMessaging();
    });
    obs.observe(aside, { childList: true, subtree: true });
  }

  document.addEventListener('DOMContentLoaded', function () {
    bindCrossSellAdd();
    initFromInitialCart();
    positionPaypalUpstreamMessaging();
    initPaypalMessagingObserver();
    var n = 0;
    var overlayBound = false;
    var t = setInterval(function () {
      n++;
      positionPaypalUpstreamMessaging();
      if (!overlayBound) {
        overlayBound = bindCartSlideoutOverlay();
      }
      var patchOk = patchCartDrawerInstance();
      if (patchOk && overlayBound) {
        clearInterval(t);
        var el = document.getElementById('initial-cart');
        if (el) {
          try {
            onCart(JSON.parse(el.textContent));
          } catch (e) {}
        }
      }
      if (n > 400) {
        clearInterval(t);
      }
    }, 25);
  });
})();
/* cart-drawer-enhancements: end */
